/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Nutritional Indicator List List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AlbuminuriaProgressListView';

export const mapStateToPropsAlbuminuriaProgressList = mapStateToProps;
export const mapDispatchToPropsAlbuminuriaProgressList = mapDispatchToProps;

export default connect(
  mapStateToPropsAlbuminuriaProgressList,
  mapDispatchToPropsAlbuminuriaProgressList
)(View);
